/**
 * CG Sign - in-house e-signing (v1, showcase).
 *
 * Envelope model, DocuSign-shaped: upload a PDF, add ordered recipients,
 * send. Each recipient signs through a tokenised public link (no login).
 * When the last one signs, the API seals the PDF - the original pages plus
 * an appended signature page and a completion-certificate page - stores it
 * in the private blob container, and records its SHA-256 as the
 * tamper-evidence anchor. Field placement on the pages themselves is v2.
 */
export const SignDocumentStatus = {
    DRAFT: 'DRAFT',
    SENT: 'SENT',
    COMPLETED: 'COMPLETED',
    DECLINED: 'DECLINED',
    VOIDED: 'VOIDED',
};
export const SIGN_DOCUMENT_STATUS_LABEL = {
    DRAFT: 'Draft',
    SENT: 'Out for signature',
    COMPLETED: 'Completed',
    DECLINED: 'Declined',
    VOIDED: 'Voided',
};
export const SignRecipientStatus = {
    PENDING: 'PENDING',
    NOTIFIED: 'NOTIFIED',
    SIGNED: 'SIGNED',
    DECLINED: 'DECLINED',
};
/**
 * What a placed box asks of its recipient.
 *
 * SIGNATURE is the signature image. COMMENT is a line of text the signer
 * may type - placed by the sender in the same way, so a form can ask for
 * "reason for claim" next to the signature rather than in a separate
 * conversation.
 */
export const SignFieldKind = {
    SIGNATURE: 'SIGNATURE',
    COMMENT: 'COMMENT',
};
export const SIGN_LIST_SCOPE_LABEL = {
    SENT_BY_ME: 'Sign sent',
    NEEDS_MY_SIGNATURE: 'Need to sign',
};
export const SIGN_TITLE_MAX = 200;
export const SIGN_MESSAGE_MAX = 1000;
export const SIGN_MAX_RECIPIENTS = 10;
/** Files per envelope; each may be a PDF, PNG or JPEG. */
export const SIGN_MAX_FILES = 10;
/** Per-file byte cap (base64 travels ~33% larger). */
export const SIGN_FILE_MAX_BYTES = 10 * 1024 * 1024;
/** ~300 KB is generous for a signature PNG. */
export const SIGN_SIGNATURE_MAX_BYTES = 300 * 1024;
export const SIGN_CATEGORY_NAME_MAX = 80;
export const SIGN_COMMENT_MAX = 500;
//# sourceMappingURL=sign.js.map